import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Sessione: l'access token dura 15 minuti. Al primo 401 tentiamo un refresh (cookie httpOnly di 7 giorni)
// e ripetiamo la richiesta una sola volta; se anche il refresh fallisce, avvisiamo l'app (auth:expired).
let refreshing = null;
const AUTH_SKIP = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/google/session", "/auth/forgot-password", "/auth/reset-password"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response && error.response.status;
    const url = cfg.url || "";
    if (status !== 401 || cfg._retried || AUTH_SKIP.some((p) => url.startsWith(p))) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      if (!refreshing) {
        refreshing = api.post("/auth/refresh").finally(() => {
          refreshing = null;
        });
      }
      await refreshing;
    } catch (e) {
      if (!url.startsWith("/auth/me")) window.dispatchEvent(new Event("auth:expired"));
      return Promise.reject(error);
    }
    return api(cfg);
  }
);

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}`;
export const resolveMediaUrl = (url) => (url && url.startsWith("/api/files/") ? fileUrl(url.replace("/api/files/", "")) : url);

export default api;
